/*
 *
 * ExpiredSessionModal
 *
 * @version 1.0.0
 * @author Pietro Bertuccelli
 * @since 24-Sep-2025
*/

import React from 'react'
import PortalMessage from 'Utility/PortalMessage'

const formattedMessage = {
  title: <PortalMessage id='t.app.expiredSessionModal.title' defaultMessage='La tua sessione è scaduta per inattività' />,
  primaryButtonLabel: <PortalMessage id='t.app.login' defaultMessage='Accedi' />
}

export default formattedMessage
